var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "details-modal-wrapper" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "confi-details", tabindex: "-1", role: "dialog" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content confi-modal" }, [
            _c("div", { staticClass: "confi-modal__container" }, [
              _c(
                "svg",
                {
                  staticClass: "confi-modal__close-button",
                  attrs: { "data-dismiss": "modal", height: "26", width: "27" },
                  on: {
                    click: function($event) {
                      return _vm.detachModal()
                    }
                  }
                },
                [
                  _c("use", {
                    attrs: {
                      "xlink:href": "#svg_close",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "confi-modal__main-img" },
                [
                  _c("transition", { attrs: { mode: "out-in" } }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.modalSelectedColor.img === _vm.modalKey,
                          expression: "modalSelectedColor.img === modalKey"
                        }
                      ],
                      attrs: {
                        src:
                          "https://bilder.weberbuero.de/frontend/images/materials/large/" +
                          _vm.modalSelectedColor.img +
                          ".jpg"
                      },
                      on: { load: _vm.setModalKey }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "confi-modal__controls" }, [
                    _c(
                      "div",
                      {
                        staticClass: "homepage-swiper__prev",
                        class: {
                          disabled:
                            _vm.modalSelectedColor.id == _vm.colorArray[0]
                        },
                        on: { click: _vm.slidePrev }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "homepage-swiper__arrow homepage-swiper__arrow--prev"
                          },
                          [
                            _c("use", {
                              attrs: {
                                "xlink:href": "#svg_arrow",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "homepage-swiper__next",
                        class: {
                          disabled:
                            _vm.modalSelectedColor.id ==
                            _vm.colorArray[_vm.lastColorKey]
                        },
                        on: { click: _vm.slideNext }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "homepage-swiper__arrow homepage-swiper__arrow--next"
                          },
                          [
                            _c("use", {
                              attrs: {
                                "xlink:href": "#svg_arrow",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "confi-modal__infos" }, [
                _c("div", { staticClass: "confi-modal__infos--left" }, [
                  _c("div", {
                    staticClass: "confi-modal__thumb--big",
                    style: {
                      backgroundImage:
                        "url(https://bilder.weberbuero.de/frontend/images/materials/thumbs/" +
                        _vm.modalSelectedColor.img +
                        ".jpg)"
                    }
                  }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "confi-modal__name" }, [
                    _vm._v(_vm._s(_vm.modalSelectedColor.name))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "confi-modal__number" }, [
                    _vm._v(_vm._s(_vm.modalSelectedColor.img))
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "confi-modal__infos--right",
                  domProps: { innerHTML: _vm._s(_vm.modalDetailsText) }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "confi-modal__bottom" }, [
              _vm.activeAttributes && _vm.activeAttributes[_vm.swiperColor]
                ? _c(
                    "ul",
                    _vm._l(
                      _vm.activeAttributes[_vm.swiperColor].values,
                      function(color, key) {
                        return _c("li", {
                          staticClass: "confi-modal__thumb",
                          class: {
                            "confi-modal__thumb--active":
                              key === _vm.modalSelectedColor.id
                          },
                          style: {
                            backgroundImage:
                              "url(https://bilder.weberbuero.de/frontend/images/materials/thumbs/" +
                              color.split(" ")[0] +
                              ".jpg)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectModalColor(key)
                            }
                          }
                        })
                      }
                    ),
                    0
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }